export default "__VITE_ASSET__DZ60GMr9__"